<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10B9AoA/tc-custom/9781442413863.jpg?1730492332738" alt="This image is the cover for the book Gone, Wake Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gone, Wake Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>Things should be great for Janie—she has graduated from high school and is spending her summer with Cabel, the guy she’s totally in love with. But deep down she’s panicking about how she’s going to survive her future when getting sucked into other people’s dreams is really starting to take its toll. <br/><br/>Things get even more complicated when she meets her father for the very first time—and he’s in a coma. As Janie uncovers his secret past, she begins to realize that the choice thought she had has more dire consequences than she ever imagined.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa McMann
      </h2>
      
      <p class="authorDescription body article">Lisa McMann lives in Arizona. She is married to fellow writer and musician, Matt McMann, and they have two adult children. Her son is an artist named Kilian McMann and her daughter is an actor, Kennedy McMann.&#160;Lisa is the&#160;<I>New York Times&#160;</I>bestselling author of over two dozen books for young adults and children. So far she has written in genres including paranormal, realistic, dystopian, and fantasy. Some of her most well-known books are The Unwanteds series for middle grade readers and the Wake trilogy for young adults. Check out Lisa&#39;s website at LisaMcMann.com, learn more about The Unwanteds Series at UnwantedsSeries.com, and be sure to say hi on Instagram or Twitter (@Lisa_McMann), or Facebook (Facebook.com/McMannFan).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      S&S Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ed430fc